import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialZoomOutPage: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.48 9.14H32v4.57h-1.52Zm0-7.62H32v4.57h-1.52Zm0 24.38h-1.53v-1.52h-1.52v-1.52h-1.52v3.04h-3.05v1.53h1.52v1.52h1.53v1.53h1.52V32h3.05v-1.52H32v-3.05h-1.52zM25.91 0h4.57v1.52h-4.57Zm1.52 18.28h1.52v4.58h-1.52Zm-1.52-3.04h1.52v3.04h-1.52Zm-9.15 4.57h7.62v1.52h-7.62Zm6.1-6.1h3.05v1.53h-3.05Zm-4.57 13.72h4.57v1.52h-4.57Zm0-15.24h4.57v1.52h-4.57Zm0-12.19h4.57v1.52h-4.57Zm-3.05 25.9h3.05v1.53h-3.05Zm0-12.19h3.05v1.53h-3.05Zm-1.52 9.15h1.52v3.04h-1.52Zm0-7.62h1.52v3.04h-1.52Zm-1.53 3.04h1.53v4.58h-1.53Zm-3.04 12.2h4.57V32H9.15ZM9.15 0h4.57v1.52H9.15ZM1.53 30.48H6.1V32H1.53ZM1.53 0H6.1v1.52H1.53ZM0 25.9h1.53v4.58H0Zm0-7.62h1.53v4.58H0Zm0-9.14h1.53v4.57H0Zm0-7.62h1.53v4.57H0Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialZoomOutPage
